import { find, uniqBy, some } from "lodash";

import config from "../../common/config";
import $ from "jquery";

const orderToScan = ["4", "3", "2", "1", "0"];

export function showLoader() {
  $("#loaderWrap").show();
}

export function hideLoader() {
  $("#loaderWrap").hide();
}

export function calculatePercentile(popStats, isLive) {
  let barGraph = isLive ? popStats.fixtures : barGraphData(popStats);
  const flatAllPoints = barGraph.map((el) => el.points.tPoints);
  const maxTotalPoints = Math.max.apply(undefined, flatAllPoints);
  barGraph = barGraph.map((fixture) => {
    fixture.totalPointPercent =
      +maxTotalPoints === 0
        ? 0
        : (fixture.points.tPoints / maxTotalPoints) * 100;
    return fixture;
  });
  return barGraph;
}

const barGraphData = (popStats) => {
  let uniqueFixture = uniqBy(popStats.fixtures, "mdId");
  return uniqueFixture.map((item) => {
    let points = find(popStats.points, { mId: item.mId });
    let stats = find(popStats.stats, { mId: item.mId });
    item.points = points;
    item.stats = stats;
    return item;
  });
};

export function getTeamDeadlineObj(
  trans,
  OffSet = "+0",
  MDeadline,
  month = "ddMMM",
  dateWithTime = false,
  ddMMMWithoutTime = false
) {
  let deadlineObj = {};
  let isSubsDeadline = false;
  let isTeamLockDeadline = false;
  // if (ViewState) {
  //     const subsPossible =
  //         (ViewState === config.possibleActions["substitution"]);
  //     const transferPossible = (ViewState === config.possibleActions["transfer"]);
  //     const subsAndTransferPossible = (ViewState === config.possibleActions["subsAndTransfer"]);
  //     isSubsDeadline = subsPossible;
  //     isTeamLockDeadline = (transferPossible || subsAndTransferPossible);
  // }
  let matchTime = "";
  let displayDate = "";
  let Deadline = MDeadline;
  // if (Deadline) {
  //     let dateParams = {
  //         matchTime: Deadline,
  //         offSet: OffSet,
  //         dateWithTime: dateWithTime,
  //         ddMMMWithoutTime: ddMMMWithoutTime,
  //         month: month
  //     }

  //     Deadline = cestToLocalTime(dateParams);
  //     Deadline = moment(new Date(Deadline));
  //     let date = Deadline.format('DD MMM');
  //     matchTime = Deadline.format('HH:mm');
  //     let dateWithYear = Deadline.format('DD MMM YYYY');

  //     displayDate = date;
  //     deadlineObj.displayDate = displayDate;
  //     deadlineObj.matchTime = matchTime;
  //     deadlineObj.dateWithYear = dateWithYear;
  //     deadlineObj.dateWithYearAndTime = dateWithYear + " " + matchTime
  //     if (isSubsDeadline) {
  //         deadlineObj.deadlineText = trans.substitutionsUntil + ' ' + displayDate + ', ' + matchTime;
  //     } else if (isTeamLockDeadline) {
  //         deadlineObj.isLockIcon = true;
  //         deadlineObj.deadlineText = trans.teamLock + ': ' + displayDate + ', ' + matchTime;
  //     } else {
  //         deadlineObj.isLockIcon = true;
  //         deadlineObj.deadlineText = trans.teamLock + ': ' + displayDate + ', ' + matchTime;
  //     }
  // }
  if (Deadline) {
    let dateParams = {
      matchTime: Deadline,
      offSet: OffSet,
      dateWithTime: dateWithTime,
      ddMMMWithoutTime: ddMMMWithoutTime,
      month: month,
    };

    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthNamesShort = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const dayNamesShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    Deadline = cestToLocalTime(dateParams);
    // Deadline = moment(new Date(Deadline));

    let daysNameShort = dayNamesShort[Deadline.getDay()];
    let daysNameLong = dayNames[Deadline.getDay()];
    let dayInt = ("0" + Deadline.getDate()).slice(-2);
    let monthsNameShort = monthNamesShort[Deadline.getMonth()];
    let monthsNameLong = monthNames[Deadline.getMonth()];
    let monthInt = ("0" + Deadline.getMonth()).slice(-2);
    let year = Deadline.getFullYear();
    let date = dayInt + " " + monthsNameShort;

    let getHours = ("0" + Deadline.getHours()).slice(-2);
    let getMinutes = ("0" + Deadline.getMinutes()).slice(-2);
    matchTime = getHours + ":" + getMinutes;

    let dateWithYear = dayInt + " " + monthsNameShort + " " + year;

    displayDate = date;
    deadlineObj.dayShort = daysNameShort;
    deadlineObj.dayLong = daysNameLong;
    deadlineObj.displayDate = displayDate;
    deadlineObj.displayDatewithDay = deadlineObj.dayShort + " " + displayDate;
    deadlineObj.matchTime = matchTime;
    deadlineObj.dateWithYear = dateWithYear;
    deadlineObj.dateWithYearAndTime = dateWithYear + " " + matchTime;
    deadlineObj.dateAndTime = date + ", " + matchTime;
    deadlineObj.dateAndTimewithday =
      deadlineObj.dayShort + " " + date + ", " + matchTime;
    if (isSubsDeadline) {
      deadlineObj.deadlineText =
        trans.substitutionsUntil + " " + displayDate + ", " + matchTime;
    } else if (isTeamLockDeadline) {
      deadlineObj.isLockIcon = true;
      deadlineObj.deadlineText =
        trans.teamLock + ": " + displayDate + ", " + matchTime;
    } else {
      deadlineObj.isLockIcon = true;
      deadlineObj.deadlineText =
        trans.teamLock + ": " + displayDate + ", " + matchTime;
    }
  }
  return deadlineObj;
}

export function cestToLocalTime(dateObj) {
  var date = new Date(dateObj.matchTime);

  //CEST is 2 hrs (daylight saving--offset value) ahead of GMT hence substracted 2
  date = date.setHours(date.getHours() - dateObj.offSet); //Converted to GMT time
  date = new Date(date);
  var localOffset = new Date().getTimezoneOffset() * 60000;
  var localTime = date.getTime();
  date = localTime - localOffset;
  date = new Date(date);

  return date;
}

export function isPlayerInTeam(playerID, teamData) {
  if (teamData && teamData.playersInTeam) {
    return teamData.playersInTeam.indexOf(playerID) > -1;
  } else {
    return false;
  }
}

export function getPlayerInteam(playerID, teamData) {
  if (teamData && teamData.playersInTeam) {
    if (teamData.playersInTeam.indexOf(playerID) > -1) {
      let playerData = {};
      find(orderToScan, (position) => {
        return find(teamData[position], (player, index) => {
          if (player.id === playerID) {
            playerData = player;
            return true;
          }
          return false;
        });
      });
      return playerData;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

export function isPlayerInRecover(id, tData) {
  let isPlayerNull = false;
  const orderToScan = ["4", "3", "2", "1", "0"];
  find(orderToScan, (position) => {
    find(tData[position], (player, index) => {
      if (player.id === null && player.DBDetails.id == id) {
        isPlayerNull = {
          skill: player.skill,
          rowIndex: position,
          playerIndex: index,
        };
      }
    });
  });
  return isPlayerNull;
}

export function isPlayerInBench(playerID, teamData) {
  return some(teamData["0"], (player) => {
    return player.id == playerID;
  });
}

export function isCaptain(playerID, teamData) {
  return playerID == teamData.captainID;
}

export function canPlayerSubstitute(player) {
  const { DBDetails } = player;
  const IsPlayed = +DBDetails.isplayed === 1;
  const isBench = DBDetails["benchposition"] > 0;
  const RC = DBDetails["isredcard"] === 1;
  if (isBench && IsPlayed) {
    return false;
  }
  return !RC;
}

export const makeClasses = (obj = {}) => {
  return Object.keys(obj)
    .filter((key) => obj[key])
    .join(" ");
};

export const getCurrMd = (gamedays) => {
  for (let g in gamedays) {
    if (
      (gamedays[g] && gamedays[g].mds == config.modes.live) ||
      (gamedays[g] && gamedays[g].mds == config.modes.substitution) ||
      (gamedays[g] && gamedays[g].mds == config.modes.transfer)
    ) {
      return g;
    }
  }
  return null;
};
